import { useEffect, useState, useContext } from "react";

import Spinner from "../../../../shared/components/spinner/spinner";
import AuthContext from "../../../../shared/context/auth-context";
import useHttp from "../../../../shared/hooks/use-http";
import { getAllData } from "../../../../shared/utils/api";
import { IObject, validateLoadingStatusNew } from "../../../../shared/utils/utils";
import NetworkGraph, { INetworkGraphEdge, INetworkGraphNode } from "../../../components/network-graph/network-graph";
import "./network.scss";

interface INetworkProps {
  alertcaseId: string;
}

const Network = ({ alertcaseId }: INetworkProps) => {
  const authCtx = useContext(AuthContext);
  const [nodes, setNodes] = useState<INetworkGraphNode[]>([]);
  const [edges, setEdges] = useState<INetworkGraphEdge[]>([]);

  const { sendRequest: getDatamodelGraph, status: getDatamodelGraphStatus, data: getDatamodelGraphData, error: getDatamodelGraphError } = useHttp(getAllData, false, authCtx.token, "default", "manager");

  useEffect(() => {
    getDatamodelGraph(`network_graph/ALERTCASE/${alertcaseId}`);
  }, [alertcaseId]);

  const determineNodeLabel = (nodeName: string, nodeType: string) => {
    if (nodeType.toLocaleLowerCase() !== "alertcase" && nodeType.toLocaleLowerCase() !== "aggregatoralertcase") {
      return `${nodeName} (${nodeType})`
    }
    return nodeName
  }

  useEffect(() => {
    if (getDatamodelGraphStatus === "completed" && !getDatamodelGraphError && getDatamodelGraphData) {
      const { nodes, edges } = getDatamodelGraphData;
      setNodes(nodes.map((n: IObject) => ({
        data: {
          id: n.id,
          label: determineNodeLabel(n.name, n.type),
          type: n.type,
          type_detail: n.type
        }
      })));
      setEdges(edges.map((e: IObject) => ({ data: {
        source: e.source,
        target: e.target,
        label: e.label
      } })));
    }
  }, [getDatamodelGraphStatus, getDatamodelGraphError, getDatamodelGraphData]);

  return (
    <div className="network">
      {validateLoadingStatusNew([getDatamodelGraphStatus]) && <Spinner />}
      <NetworkGraph nodes={nodes} edges={edges} allowSearch={true} />
    </div>
  );
};

export default Network;
